export const getPatientPartners = (page = 1, successCallback, filters = {}) => {
  let query = {};
  if (filters.age) {
    query.age = filters.age;
  }
  if (filters.gender) {
    query.gender = filters.gender;
  }
  if (filters.procedures) {
    query.procedures = filters.procedures;
  }

  fetch(`/patient_partners?${objToQueryString(query)}&page=${page}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const getPatientPartner = (id, successCallback) => {
  fetch(`/patient_partners/${id}`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};

export const getFilterableTreatments = (successCallback) => {
  fetch(`/patient_partners/filterable_treatments`, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => response.json())
    .then((data) => {
      successCallback(data);
    });
};
